import { useDraggable } from '@dnd-kit/core'
import './Toolbar.css'

interface ToolbarButtonProps {
  type: 'textfield' | 'slider' | 'checkbox' | 'dropdown'
  icon: string
  label: string
}

function ToolbarButton({ type, icon, label }: ToolbarButtonProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `toolbar-${type}`,
  })

  const getButtonClassName = () => {
    const classes = ['toolbar-button']
    if (isDragging) classes.push('dragging')
    return classes.join(' ')
  }

  return (
    <button
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={getButtonClassName()}
      title="ドラッグしてプロパティパネルに追加"
    >
      {icon} {label}
    </button>
  )
}

function Toolbar() {
  return (
    <div className="toolbar">
      <div className="toolbar-section">
        <h3>UI要素</h3>
        <ToolbarButton type="textfield" icon="◽" label="テキスト" />
        <ToolbarButton type="slider" icon="━⬤━" label="スライダー" />
        <ToolbarButton type="checkbox" icon="☐" label="チェックボックス" />
        <ToolbarButton type="dropdown" icon="▼" label="ドロップダウン" />
      </div>
    </div>
  )
}

export default Toolbar
